import { useMutation, useQuery } from "@tanstack/react-query";
import { StatusRepository } from "./repositories/status-repository";
import { queryClient } from "./http-client/base-client";
import { useUser } from "./user";
import { Spin } from "@/ui/spin";

export const useStatus = () => {
  return useQuery({
    queryKey: ["status"],
    queryFn: StatusRepository.fetchStatus,
    staleTime: 60_000, // 1 минута до инвалидации
  });
};

export const usePostStatus = () => {
  return useMutation({
    mutationFn: StatusRepository.postStatus,
    onSuccess: () => {
      // Обработка успешной отправки
      queryClient.invalidateQueries({ queryKey: ["status"] });
      console.log("Status submitted:");
    },
    onError: (error) => {
      // Обработка ошибки
    },
  });
};


export const useUserStatus = () => {
  const { data: status, isLoading } = useStatus();
  const { data: user, isLoading: isLoadingUser } = useUser();

  if (isLoading || isLoadingUser) {
    return true;
  }

  return status?.isAvailable || user?.role === 'admin';
}